<template>
  <section class="v2026-toolbar">
    <div class="v2026-toolbar-icons">
      <button ref="quickFilterBtn" type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showQuickFilter }"
              title="ตัวกรอง" aria-label="ตัวกรอง"
              :aria-expanded="showQuickFilter" aria-controls="v2026-quickfilter-card"
              @click="togglePanel('quickfilter')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.chatAdd + ')', 'mask-image': 'url(' + toolIcons.chatAdd + ')' }"></span>
      </button>
      <button type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showSearch }"
              title="ค้นหา" aria-label="ค้นหา"
              @click="togglePanel('search')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.search + ')', 'mask-image': 'url(' + toolIcons.search + ')' }"></span>
      </button>
      <button ref="tagBtn" type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showTag }"
              title="แท็ก" aria-label="แท็ก"
              @click="togglePanel('tag')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.tag + ')', 'mask-image': 'url(' + toolIcons.tag + ')' }"></span>
      </button>
      <!-- "รับเคสแล้ว" ล็อกเป็นเคสของตัวเองอยู่แล้ว — ตัวกรองแอดมินไม่มีความหมาย -->
      <button v-show="menuType !== 'my_inbox'"
              ref="adminBtn" type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showAdmin }"
              title="ค้นหา Admin" aria-label="ค้นหา Admin"
              :aria-expanded="showAdmin" aria-controls="v2026-admin-card"
              @click="togglePanel('admin')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.contact + ')', 'mask-image': 'url(' + toolIcons.contact + ')' }"></span>
      </button>
      <button v-if="customerType === 'beneat_professional'"
              ref="groupBtn" type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showGroup }"
              title="กลุ่มของคุณแม่บ้าน" aria-label="กลุ่มของคุณแม่บ้าน"
              :aria-expanded="showGroup" aria-controls="v2026-group-card"
              @click="togglePanel('group')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.userGroup + ')', 'mask-image': 'url(' + toolIcons.userGroup + ')' }"></span>
      </button>
      <button v-if="showRecruitmentCreatedDateFilter"
              type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showDate }"
              title="วันที่เริ่มสนทนา" aria-label="วันที่เริ่มสนทนา"
              :aria-expanded="showDate" aria-controls="v2026-date-panel"
              @click="togglePanel('date')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.calendar + ')', 'mask-image': 'url(' + toolIcons.calendar + ')' }"></span>
      </button>
      <button v-if="showAssignedWithinFilter"
              ref="assignedWithinBtn" type="button" class="v2026-tool-btn"
              :class="{ 'is-active': showAssignedWithin }"
              title="ค้นหาแชทตามช่วงเวลา" aria-label="ค้นหาแชทตามช่วงเวลา"
              :aria-expanded="showAssignedWithin" aria-controls="v2026-aw-card"
              @click="togglePanel('assignedWithin')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.calendar + ')', 'mask-image': 'url(' + toolIcons.calendar + ')' }"></span>
      </button>
      <button v-if="useTopicFilterOnRecruitment || !showRecruitmentCreatedDateFilter"
              ref="filterBtn" type="button" class="v2026-tool-btn v2026-tool-btn--end"
              :class="{ 'is-active': showFilter }"
              title="กรองตามหัวข้อ" aria-label="กรองตามหัวข้อ"
              :aria-expanded="showFilter" aria-controls="v2026-topic-card"
              @click="togglePanel('filter')">
        <span class="v2026-tool-svg-mask" aria-hidden="true"
              :style="{ '-webkit-mask-image': 'url(' + toolIcons.filter + ')', 'mask-image': 'url(' + toolIcons.filter + ')' }"></span>
      </button>
    </div>

    <div class="v2026-admin-indicators" v-if="hasAdminFilter">
      <div class="v2026-admin-indicator" v-for="a in selectedAdmins" :key="'sel-admin-' + a.id">
        <img class="v2026-admin-indicator__avatar"
             :src="a.profile_picture || require('@/assets/no_photos.png')"
             @error="$event.target.src = require('@/assets/no_photos.png')"
             width="28" alt="">
        <span class="v2026-admin-indicator__name">{{ a.name }}</span>
        <button type="button" class="v2026-admin-indicator__remove"
                :aria-label="'ยกเลิกการเลือกแอดมิน: ' + a.name"
                @click="toggleAdmin(a)">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="v2026-group-indicator"
         v-if="customerType === 'beneat_professional' && professionalGroup !== null">
      <span class="v2026-group-indicator__check" aria-hidden="true">
        <i class="fas fa-check-circle"></i>
      </span>
      <span class="v2026-group-indicator__name">{{ professionalGroupLabel }}</span>
      <button type="button" class="v2026-group-indicator__remove"
              :aria-label="'ยกเลิกการเลือกกลุ่ม: ' + professionalGroupLabel"
              @click="professionalGroup = null; searchConversation()">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="v2026-group-indicator"
         v-if="customerType === 'beneat_professional' && selectedProfessional">
      <img class="v2026-pro-indicator__avatar"
           :src="selectedProfessional.picture_url || require('@/assets/no_photos.png')"
           @error="$event.target.src = require('@/assets/no_photos.png')"
           width="24" height="24" alt="">
      <span class="v2026-group-indicator__name">{{ selectedProfessionalLabel }}</span>
      <button type="button" class="v2026-group-indicator__remove"
              :aria-label="'ยกเลิกการเลือกคุณแม่บ้าน: ' + selectedProfessionalLabel"
              @click="selectedProfessional = null; searchConversation()">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="v2026-filter-groups" v-if="hasFilterGroups">
        <span class="v2026-filter-group__title">ตัวกรองด่วน</span>
        <div class="v2026-active-filters" aria-label="ตัวกรองที่เลือก">
          <span class="v2026-filter-chip" v-if="unread === 1">
            <i class="far fa-check-circle v2026-filter-chip-check" aria-hidden="true"></i>
            <span class="v2026-filter-chip-label">ข้อความที่ยังไม่ได้อ่าน</span>
            <button type="button" class="v2026-filter-chip-remove"
                    aria-label="ลบตัวกรอง: ข้อความที่ยังไม่ได้อ่าน"
                    @click="removeQuickFilter('unread')">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
          <span class="v2026-filter-chip" v-if="isNotResponse === 1">
            <i class="far fa-check-circle v2026-filter-chip-check" aria-hidden="true"></i>
            <span class="v2026-filter-chip-label">ข้อความที่ยังไม่ได้ตอบ</span>
            <button type="button" class="v2026-filter-chip-remove"
                    aria-label="ลบตัวกรอง: ข้อความที่ยังไม่ได้ตอบ"
                    @click="removeQuickFilter('isNotResponse')">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
          <span class="v2026-filter-chip" v-if="reminderChipVisible">
            <i class="far fa-check-circle v2026-filter-chip-check" aria-hidden="true"></i>
            <span class="v2026-filter-chip-label">ข้อความที่มีการแจ้งเตือน</span>
            <button type="button" class="v2026-filter-chip-remove"
                    aria-label="ลบตัวกรอง: ข้อความที่มีการแจ้งเตือน"
                    @click="removeQuickFilter('isReminder')">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
          <span class="v2026-filter-chip" v-if="assignedWithinChipLabel">
            <i class="far fa-check-circle v2026-filter-chip-check" aria-hidden="true"></i>
            <span class="v2026-filter-chip-label">{{ assignedWithinChipLabel }}</span>
            <button type="button" class="v2026-filter-chip-remove"
                    :aria-label="'ลบตัวกรอง: ' + assignedWithinChipLabel"
                    @click="selectAssignedWithin(null)">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
          <span class="v2026-filter-chip" v-if="emergencyChipVisible">
            <i class="far fa-check-circle v2026-filter-chip-check" aria-hidden="true"></i>
            <span class="v2026-filter-chip-label">ด่วน!</span>
            <button type="button" class="v2026-filter-chip-remove"
                    aria-label="ลบตัวกรอง: ด่วน!"
                    @click="removeQuickFilter('isEmergency')">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
        </div>

      <hr class="v2026-filter-groups__divider" v-if="hasSelectedTagChips && hasActiveQuickFilters">

      <div class="v2026-filter-group" v-if="hasSelectedTagChips">
        <span class="v2026-filter-group__title">แท็กที่เลือก</span>
        <div class="v2026-tag-chips" aria-label="แท็กที่เลือก">
          <span v-for="tag in selectedTagChips" :key="tag.id"
                class="v2026-tag-chip" :title="tag.name"
                :style="{ color: tag.color || 'var(--v2026-color-main)', borderColor: tag.color || 'var(--v2026-color-main)' }">
            <i class="fas fa-tag v2026-tag-chip__ico" aria-hidden="true"></i>
            <span class="v2026-tag-chip__label">{{ tag.name }}</span>
            <button type="button" class="v2026-tag-chip__remove"
                    :aria-label="'ลบแท็ก: ' + tag.name"
                    @click.stop="toggleTagPill(tag)">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      </div>

      <hr class="v2026-filter-groups__divider"
          v-if="hasSelectedTopicChips && (hasActiveQuickFilters || hasSelectedTagChips)">

      <div class="v2026-filter-group" v-if="hasSelectedTopicChips">
        <span class="v2026-filter-group__title">หัวข้อที่เลือก</span>
        <div class="v2026-tag-chips" aria-label="หัวข้อที่เลือก">
          <span v-for="tag in selectedTopicChips" :key="tag.id"
                class="v2026-tag-chip" :title="tag.name"
                :style="{ color: tag.color || 'var(--v2026-color-main)', borderColor: tag.color || 'var(--v2026-color-main)' }">
            <i class="fas fa-tag v2026-tag-chip__ico" aria-hidden="true"></i>
            <span class="v2026-tag-chip__label">{{ tag.name }}</span>
            <button type="button" class="v2026-tag-chip__remove"
                    :aria-label="'ลบหัวข้อ: ' + tag.name"
                    @click.stop="toggleTagPill(tag)">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      </div>
    </div>

    <overlay-card id="v2026-quickfilter-card" class="v2026-quickfilter-pos"
         :open="showQuickFilter" v-show="showQuickFilter" :ignore="quickFilterBtnEl"
         :render-key="quickFilterRenderKey"
         @close="showQuickFilter = false"
         role="region" aria-labelledby="v2026-quickfilter-card-title">
      <template #default="qf">
      <div id="v2026-quickfilter-card-title" class="v2026-quickfilter-card-title" :data-rk="qf.dirty">เลือกตัวกรอง</div>
      <div class="form-group mb-0" style="font-size: 85%;">
        <div class="custom-control custom-checkbox mb-0 v2026-qf-check">
          <input type="checkbox" class="custom-control-input cursor-pointer"
                 :true-value="1" :false-value="0" v-model="unread" @change="searchConversation()"
                 id="unread-check" name="unread-check">
          <label class="custom-control-label cursor-pointer" for="unread-check">ข้อความที่ยังไม่ได้อ่าน</label>
        </div>
        <div class="custom-control custom-checkbox mb-0 v2026-qf-check">
          <input type="checkbox" class="custom-control-input cursor-pointer"
                 :true-value="1" :false-value="0" v-model="isNotResponse" @change="searchConversation()"
                 id="response-check" name="response-check">
          <label class="custom-control-label cursor-pointer" for="response-check">ข้อความที่ยังไม่ได้ตอบ</label>
        </div>
        <div class="custom-control custom-checkbox mb-0 v2026-qf-check"
             v-if="(searchConversationParams && searchConversationParams.customer_type === 'customer' && searchConversationParams.menu !== 'reminder')">
          <input type="checkbox" class="custom-control-input cursor-pointer"
                 :true-value="1" :false-value="0" v-model="isReminder" @change="searchConversation()"
                 id="is-reminder-check" name="is-reminder-check">
          <label class="custom-control-label cursor-pointer" for="is-reminder-check">ข้อความที่มีการแจ้งเตือน</label>
        </div>
        <div class="custom-control custom-checkbox mb-0 v2026-qf-check"
             v-if="(searchConversationParams && searchConversationParams.customer_type === 'customer')">
          <input type="checkbox" class="custom-control-input cursor-pointer"
                 :true-value="1" :false-value="0" v-model="isEmergency" @change="searchConversation()"
                 id="is-emergency-check" name="is-emergency-check">
          <label class="custom-control-label cursor-pointer" for="is-emergency-check">ด่วน!</label>
        </div>
      </div>
      </template>
    </overlay-card>

    <div class="v2026-tool-panel" v-show="showSearch">
      <div class="v2026-search-field">
        <i class="fas fa-search v2026-search-icon" aria-hidden="true"></i>
        <input type="search"
               class="form-control form-control-sm v2026-search-input"
               :placeholder="customerType === 'beneat_professional' ? 'ค้นหา หรือระบุชื่อ / ID คุณแม่บ้าน' : 'ค้นหา...'"
               v-model="keyword"
               :aria-expanded="proSuggestOpen ? 'true' : 'false'"
               :aria-controls="proSuggestOpen ? 'v2026-prosuggest' : null"
               :aria-activedescendant="proSuggestIndex >= 0 ? 'v2026-prosuggest-' + proSuggestIndex : null"
               @input="onKeywordInput($event.target.value)"
               @keydown.down.prevent="moveProSuggest(1)"
               @keydown.up.prevent="moveProSuggest(-1)"
               @keydown.esc="closeProSuggest()"
               @blur="closeProSuggest()"
               @keyup.enter="onSearchEnter()">
        <!-- Maid rail only: the legacy maid picker's suggestions, surfaced in the main search box.
             mousedown.prevent keeps the input focused so blur does not close the list mid-click. -->
        <div v-if="proSuggestOpen" id="v2026-prosuggest" class="v2026-prosuggest"
             role="listbox" aria-label="คุณแม่บ้านที่ตรงกับคำค้น">
          <div v-if="proSuggestLoading" class="v2026-prosuggest__empty">กำลังค้นหา...</div>
          <div v-else-if="!professionals.length" class="v2026-prosuggest__empty">ไม่พบคุณแม่บ้าน</div>
          <template v-else>
            <div v-for="(p, i) in professionals" :key="'pro-sug-' + p.id"
                 :id="'v2026-prosuggest-' + i" role="option"
                 class="v2026-prosuggest__row" :class="{ 'is-active': i === proSuggestIndex }"
                 :aria-selected="i === proSuggestIndex ? 'true' : 'false'"
                 @mousedown.prevent
                 @mouseenter="proSuggestIndex = i"
                 @click="pickProfessional(p)">
              <img class="v2026-prosuggest__avatar"
                   :src="p.picture_url || require('@/assets/no_photos.png')"
                   @error="$event.target.src = require('@/assets/no_photos.png')"
                   width="32" height="32" alt="">
              <span class="v2026-prosuggest__name">{{ 'ID:' + p.id + ' ' + p.full_name }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div id="v2026-date-panel" class="v2026-tool-panel v2026-date-panel"
         v-show="showDate && showRecruitmentCreatedDateFilter">
      <div class="v2026-date-row">
        <div class="v2026-date-field" :class="{ 'is-open': showDateCalendar }">
          <button type="button" ref="dateFieldBtn" class="v2026-date-hit"
                  aria-haspopup="grid"
                  :aria-expanded="showDateCalendar ? 'true' : 'false'"
                  aria-controls="v2026-date-calendar"
                  :aria-label="'วันที่เริ่มสนทนา: ' + conversationCreatedDateLabel"
                  @click="toggleDateCalendar()"></button>
          <span class="v2026-date-value"
                :class="{ 'is-empty': !conversationCreatedDate }">{{ conversationCreatedDateLabel }}</span>
          <!-- FA js/all.js เปลี่ยน <i> เป็น <svg> ของมันเอง — จัดตำแหน่งที่ span อย่าผูกกับ i -->
          <span class="v2026-date-icon" aria-hidden="true"><i class="far fa-calendar-alt"></i></span>
        </div>
        <button v-if="conversationCreatedDate" type="button" class="v2026-date-clear"
                aria-label="ล้างวันที่เริ่มสนทนา" title="ล้างวันที่เริ่มสนทนา"
                @click="clearCreatedDate()">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>

      <overlay-card id="v2026-date-calendar" class="v2026-date-calpos"
                    :open="showDateCalendar" v-show="showDateCalendar"
                    :ignore="dateFieldEl"
                    :render-key="dateCalendarRenderKey"
                    @close="showDateCalendar = false"
                    role="dialog" aria-label="เลือกวันที่เริ่มสนทนา">
        <template #default="dc">
          <div :data-rk="dc.dirty">
            <MonthCalendarV2026 :month="createdDateMonth"
                                :selectedDate="conversationCreatedDateStr"
                                :showCreateButton="false"
                                yearMode="gregorian"
                                @month-change="ym => (createdDateMonth = ym)"
                                @select="onCreatedDateSelect"/>
          </div>
        </template>
      </overlay-card>
    </div>

    <overlay-card id="v2026-tag-card" class="v2026-tagpanel-pos"
         :open="showTag" v-show="showTag" :ignore="tagBtnEl"
         :render-key="tagCardRenderKey"
         @close="showTag = false"
         role="region" aria-label="แท็ก">
      <!-- The scoped slot + a reference to its `dirty` key is what marks this slot UNSTABLE.
           Without it Vue 2.7's stable-slot optimisation freezes the rows. -->
      <template #default="ts">
      <div class="v2026-tagpanel-search" :data-rk="ts.dirty">
        <i class="fas fa-search v2026-tagpanel-search__ico" aria-hidden="true"></i>
        <input v-model.trim="tagFilterQuery" type="text"
               class="v2026-tagpanel-search__input"
               placeholder="ค้นหา Tags" aria-label="ค้นหา Tags">
      </div>

      <div class="v2026-tagpanel-list" role="listbox" v-if="tags">
        <div v-for="tag in filteredToolbarTags" :key="tag.id + '|' + (hasSelectTagId(tag.id) ? 1 : 0)"
             class="v2026-tagpanel-row" role="option"
             :class="{ 'is-selected': hasSelectTagId(tag.id) }"
             :aria-selected="hasSelectTagId(tag.id)"
             :aria-label="tag.name"
             :style="{ color: tag.color || 'var(--v2026-color-main)', borderColor: tag.color || 'var(--v2026-color-main)' }"
             @click="toggleTagPill(tag)">
          <i class="fas fa-tag v2026-tagpanel-row__ico" aria-hidden="true"></i>
          <span class="v2026-tagpanel-row__name">{{ tag.name }}</span>
          <i v-if="hasSelectTagId(tag.id)" class="fas fa-check v2026-tagpanel-row__check" aria-hidden="true"></i>
        </div>
        <div v-if="!filteredToolbarTags.length" class="v2026-tagpanel-empty">
          {{ tagFilterQuery ? 'ไม่พบแท็ก' : 'ยังไม่มีแท็ก' }}
        </div>
      </div>

      <div class="v2026-tagpanel-foot">
        <div class="v2026-andor">
          <span class="v2026-andor__label">{{ filterByAndOr === 1 ? 'และ' : 'หรือ' }}</span>
          <label class="v2026-andor__switch">
            <input type="checkbox" class="cursor-pointer"
                   :true-value="1" :false-value="0" v-model="filterByAndOr"
                   @change="searchConversation()"
                   id="filter-by-and-or" name="filterByAndOr">
            <span class="v2026-andor__slider" aria-hidden="true"></span>
          </label>
          <p style="margin: 0;" class="filter-tooltip v2026-andor__info"
             :data-tooltip="filterByAndOr === 1 ? 'ใช้การค้นหาแบบ และ (AND) หมายถึงต้องมี tag ตรงตามที่เลือกทั้งหมดจึงจะแสดง' : 'ใช้การค้นหาแบบ หรือ (OR) หมายถึงมี tag ตรงตามที่เลือกอย่างน้อย 1 ตัวก็จะแสดง'">
            <i class="fas fa-info-circle"></i>
          </p>
        </div>
        <div class="v2026-tagpanel-foot__setting" role="button" tabindex="0"
             @click="goToTagSetting()" @keydown.enter="goToTagSetting()">
          <i class="fas fa-pencil-alt v2026-tagpanel-foot__ico" aria-hidden="true"></i>
          <span>ตั้งค่าแท็ก</span>
        </div>
      </div>
      </template>
    </overlay-card>

    <!-- เลือกได้ทีละอัน กดซ้ำที่อันเดิม = ล้าง (ใช้ @click ไม่ใช่ @change เพราะ radio ที่ติ๊กอยู่
         แล้วไม่ยิง change) -->
    <overlay-card id="v2026-aw-card" class="v2026-aw-pos"
         :open="showAssignedWithin" v-show="showAssignedWithin" :ignore="assignedWithinBtnEl"
         :render-key="assignedWithinRenderKey"
         @close="showAssignedWithin = false"
         role="region" aria-labelledby="v2026-aw-title">
      <template #default="aw">
      <div id="v2026-aw-title" class="v2026-aw-title" :data-rk="aw.dirty">ค้นหาแชทตามช่วงเวลา</div>
      <div class="v2026-aw-list" role="radiogroup" aria-labelledby="v2026-aw-title">
        <label v-for="opt in assignedWithinOptions"
               :key="opt.value + '#' + (assignedWithin === opt.value ? 1 : 0)"
               :for="'v2026-aw-' + opt.value"
               class="v2026-aw-opt"
               :class="{ 'v2026-aw-opt--on': assignedWithin === opt.value }">
          <span class="v2026-aw-check">
            <input type="radio" name="v2026-aw" class="v2026-aw-check__input cursor-pointer"
                   :id="'v2026-aw-' + opt.value"
                   :checked="assignedWithin === opt.value"
                   @click="selectAssignedWithin(opt.value)">
            <span class="v2026-aw-check__box" aria-hidden="true"></span>
          </span>
          <span class="v2026-aw-opt__label">{{ opt.label }}</span>
        </label>
      </div>
      </template>
    </overlay-card>

    <overlay-card id="v2026-admin-card" class="v2026-adminpanel-pos"
         :open="showAdmin" v-show="showAdmin" :ignore="adminBtnEl"
         :render-key="adminCardRenderKey"
         @close="showAdmin = false"
         role="region" aria-label="ค้นหา Admin">
      <!-- The scoped slot + a reference to its `dirty` key is what marks this slot UNSTABLE.
           Without it Vue 2.7's stable-slot optimisation freezes the rows. -->
      <template #default="ad">
      <div class="v2026-adminpanel-search" :data-rk="ad.dirty">
        <i class="fas fa-search v2026-adminpanel-search__ico" aria-hidden="true"></i>
        <input v-model.trim="adminFilterQuery" type="text"
               class="v2026-adminpanel-search__input"
               placeholder="ค้นหา Admin" aria-label="ค้นหา Admin">
      </div>

      <div class="v2026-adminpanel-list" role="listbox" v-if="admins">
        <!-- เลือกได้หลายคน แถวนี้คือ "ล้างทั้งหมด" ปิดการ์ดหลังกดเพราะเป็นการจบการเลือก -->
        <div class="v2026-adminpanel-row v2026-adminpanel-all" role="option"
             tabindex="0"
             :class="{ 'is-selected': !hasAdminFilter }"
             :aria-selected="!hasAdminFilter"
             aria-label="เลือกทั้งหมด"
             @click="selectAll(); showAdmin = false"
             @keydown.enter="selectAll(); showAdmin = false">
          <span class="v2026-adminpanel-all__ico" aria-hidden="true">
            <i class="fas fa-users"></i>
          </span>
          <span class="v2026-adminpanel-row__name">เลือกทั้งหมด</span>
          <i v-if="!hasAdminFilter" class="fas fa-check v2026-adminpanel-row__check" aria-hidden="true"></i>
        </div>

        <!-- Selection is baked into :key so the row RE-CREATES on change — see the slot note above.
             การ์ดไม่ปิดหลังคลิก เพราะยังต้องเลือกคนต่อไปได้ -->
        <div v-for="a in filteredAdmins" :key="String(a.id) + '|' + (isAdminSelected(a) ? 1 : 0)"
             class="v2026-adminpanel-row" role="option"
             tabindex="0"
             :class="{ 'is-selected': isAdminSelected(a) }"
             :aria-selected="isAdminSelected(a)"
             :aria-label="a.name"
             @click="toggleAdmin(a)"
             @keydown.enter="toggleAdmin(a)">
          <img class="v2026-adminpanel-row__avatar"
               :src="a.profile_picture || require('@/assets/no_photos.png')"
               @error="$event.target.src = require('@/assets/no_photos.png')"
               width="40" alt="">
          <span class="v2026-adminpanel-row__name">{{ a.name }}</span>
          <i v-if="isAdminSelected(a)" class="fas fa-check v2026-adminpanel-row__check" aria-hidden="true"></i>
        </div>

        <div v-if="!filteredAdmins.length" class="v2026-adminpanel-empty">
          {{ adminFilterQuery ? 'ไม่พบแอดมิน' : 'ยังไม่มีแอดมิน' }}
        </div>
      </div>
      </template>
    </overlay-card>

    <overlay-card id="v2026-topic-card" class="v2026-topic-pos"
         :open="showFilter" v-show="showFilter" :ignore="filterBtnEl"
         :render-key="topicCardRenderKey"
         @close="showFilter = false"
         role="region" aria-labelledby="v2026-topic-card-title">
      <template #default="tp">
      <div id="v2026-topic-card-title" class="v2026-topic-card-title" :data-rk="tp.dirty">กรองตามหัวข้อ</div>

      <div v-if="customerType === 'beneat_professional'" class="v2026-topic-prosel">
        <div class="form-group">
          <v-select label="full_name"
                    name="name"
                    v-model="selectedProfessional"
                    :filterable="false"
                    :options="professionals"
                    placeholder="ระบุชื่อ หรือ ID คุณแม่บ้าน"
                    @search="onSearchProfessional"
                    @input="searchConversation">
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            <template slot="no-options">
              กรุณาระบุรหัสหรือชื่อคุณแม่บ้าน
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <img
                  :src="option.picture_url || require('@/assets/no_photos.png')"
                  width="35"/>&nbsp;
                {{ 'ID:' + option.id + ' ' + option.full_name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center" style="font-size: 11px;">
                <img
                  :src="option.picture_url || require('@/assets/no_photos.png')"
                  width="35"/>&nbsp;
                {{ 'ID:' + option.id + ' ' + option.full_name }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="form-group">
          <select class="form-control" v-model="selectedProvinceId" @change="searchConversation()">
            <option :value="null">ทุกจังหวัด</option>
            <option v-for="(item, index) in provinces" :value="item.id" :key="index">
              {{ item.name_th }}
            </option>
          </select>
        </div>
        <!-- The professionalGroup select was RELOCATED into its own card; do not re-add it here. -->
      </div>

      <div v-if="admins && (customerType === 'beneat_professional' || customerType === 'customer')">
        <div v-if="!disableMenuTypes.includes(menuType)"
             class="v2026-topic-list"
             :role="customerType === 'beneat_professional' ? 'radiogroup' : 'group'"
             aria-labelledby="v2026-topic-card-title">
          <template v-if="customerType === 'beneat_professional'">
            <div v-for="parentChatTopic in parentChatTopics"
                 :key="parentChatTopic.id + '|' + (selectedChatTopic && selectedChatTopic.id === parentChatTopic.id ? 1 : 0)"
                 class="v2026-topic-row v2026-topic-row--radio"
                 role="radio" tabindex="0"
                 :class="{ 'is-selected': (selectedChatTopic && selectedChatTopic.id === parentChatTopic.id) }"
                 :aria-checked="(selectedChatTopic && selectedChatTopic.id === parentChatTopic.id)"
                 :aria-label="parentChatTopic.name"
                 @click="searchConversationByChatTopicIds(parentChatTopic)"
                 @keydown.enter="searchConversationByChatTopicIds(parentChatTopic)">
              <span class="v2026-topic-row__radio" aria-hidden="true"></span>
              <span class="v2026-topic-row__name">{{ parentChatTopic.name }}</span>
              <span class="v2026-topic-row__count">{{ parentChatTopic.conversation_qty }}</span>
            </div>
          </template>

          <template v-else-if="customerType === 'customer' && systemTags">
            <div class="v2026-topic-row"
                 role="checkbox" tabindex="0"
                 :key="'t0|' + (hasSelectTagId(0) ? 1 : 0)"
                 :class="{ 'is-selected': hasSelectTagId(0) }"
                 :aria-checked="hasSelectTagId(0)"
                 aria-label="ไม่ได้ติดหัวข้อสนทนา"
                 @click="onChange({id: 0, system: 1, tag_count: unTaggedConversationQty})"
                 @keydown.enter="onChange({id: 0, system: 1, tag_count: unTaggedConversationQty})">
              <span class="v2026-topic-row__check" aria-hidden="true"><i class="fas fa-check"></i></span>
              <span class="v2026-topic-row__name">ไม่ได้ติดหัวข้อสนทนา</span>
              <span class="v2026-topic-row__count">{{ unTaggedConversationQty || 0 }}</span>
            </div>
            <hr class="v2026-topic-sep">
            <div v-for="(multiLevelTag, index) in multiLevelTags" :key="'ml' + index">
              <div v-if="multiLevelTag.can_select"
                   class="v2026-topic-row"
                   role="checkbox" tabindex="0"
                   :key="multiLevelTag.id + '|' + (hasSelectTagId(multiLevelTag.id) ? 1 : 0)"
                   :class="{ 'is-selected': hasSelectTagId(multiLevelTag.id) }"
                   :aria-checked="hasSelectTagId(multiLevelTag.id)"
                   :aria-label="multiLevelTag.name"
                   @click="onChange(multiLevelTag)"
                   @keydown.enter="onChange(multiLevelTag)">
                <span class="v2026-topic-row__check" aria-hidden="true"><i class="fas fa-check"></i></span>
                <span class="v2026-topic-row__name">{{ multiLevelTag.name }}</span>
                <span class="v2026-topic-row__count">{{ multiLevelTag.tag_count }}</span>
              </div>
              <div v-else class="v2026-topic-group-header">{{ multiLevelTag.name }}</div>
              <div v-for="childTag in multiLevelTag.child_tags"
                   :key="childTag.id + '|' + (hasSelectTagId(childTag.id) ? 1 : 0)"
                   class="v2026-topic-row v2026-topic-child"
                   role="checkbox" tabindex="0"
                   :class="{ 'is-selected': hasSelectTagId(childTag.id) }"
                   :aria-checked="hasSelectTagId(childTag.id)"
                   :aria-label="childTag.name"
                   @click="onChange(childTag)"
                   @keydown.enter="onChange(childTag)">
                <span class="v2026-topic-row__check" aria-hidden="true"><i class="fas fa-check"></i></span>
                <span class="v2026-topic-row__name">{{ childTag.name }}</span>
                <span class="v2026-topic-row__count">{{ childTag.tag_count }}</span>
              </div>
            </div>
          </template>
        </div>

        <div class="v2026-topic-foot" v-if="conditionClearChatTopic">
          <button type="button" class="btn btn-danger btn-sm"
                  @click="customerType === 'customer' ? onChange(null) : clearSelectedChatTopic()">Clear หัวข้อ</button>
        </div>
      </div>
      </template>
    </overlay-card>

    <overlay-card id="v2026-group-card" class="v2026-group-pos"
         :open="showGroup" v-show="showGroup" :ignore="groupBtnEl"
         :render-key="groupCardRenderKey"
         @close="showGroup = false"
         role="region" aria-labelledby="v2026-group-card-title">
      <template #default="gp">
      <div id="v2026-group-card-title" class="v2026-group-card-title" :data-rk="gp.dirty">กลุ่มของคุณแม่บ้าน</div>
      <div class="v2026-group-list" role="radiogroup" aria-labelledby="v2026-group-card-title">
        <!-- Selection is baked into :key so the row RE-CREATES on change — see the slot note above. -->
        <div v-for="opt in professionalGroupOptions"
             :key="opt.value + '|' + (professionalGroup === opt.value ? 1 : 0)"
             class="v2026-topic-row v2026-topic-row--radio"
             role="radio" tabindex="0"
             :class="{ 'is-selected': professionalGroup === opt.value }"
             :aria-checked="professionalGroup === opt.value"
             :aria-label="opt.label"
             @click="selectProfessionalGroup(opt.value)"
             @keydown.enter="selectProfessionalGroup(opt.value)">
          <span class="v2026-topic-row__radio" aria-hidden="true"></span>
          <span class="v2026-topic-row__name">{{ opt.label }}</span>
        </div>
      </div>
      </template>
    </overlay-card>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import { nextTick } from 'vue'
import OverlayCard from '@/components/coversation/OverlayCard'
import { stripLeadingStatusEmoji } from '@/components/coversation/statusIconCatalog'
import MonthCalendarV2026 from '@/components/calendar/MonthCalendarV2026'

// ─── Single source of truth for every filter-ish value in this toolbar ──────────────
// data() spreads this factory and the rail-switch reset (syncRailBoundary) re-applies the whole
// object, so a filter declared ANYWHERE ELSE leaks across rails. A new filter needs exactly two
// edits: this factory + the payload in searchConversation(). Nothing else.
// ตัวเลือกของตัวกรอง "ค้นหาแชทตามช่วงเวลา" — value ตรงกับที่ chat-server รับใน assigned_within
// (helpers/conversationHelper.js). เลือกได้ทีละอัน
const ASSIGNED_WITHIN_OPTIONS = [
  { value: '3', label: '3 Days' },
  { value: '7', label: '7 Days' },
  { value: '30', label: '30 Days' },
  { value: 'over_30', label: 'มากกว่า 30 Days' }
]

// rail ที่ตัวกรองนี้ทำงาน — แชทกับคุณลูกค้า ทุกเมนู
const ASSIGNED_WITHIN_RAIL = 'customer'

// แผนกที่เห็นปุ่มนี้ (tb_department ฐาน beneat)
//   4  = IT — ใส่ไว้ให้ทีมพัฒนาเห็นตอนทดสอบ ไม่ใช่ผู้ใช้จริงของฟีเจอร์
//   13 = BC Big Cleaning Management
//   14 = BS Big Cleaning Sales — ถูกลบเมื่อ 2026-07-03 แต่ยังมีแอดมินค้างอยู่ 14 คนบน
//        production (มากกว่า 13 ที่มี 12 คน) ตัดออกจะเสียคนมากกว่าที่ได้
const ASSIGNED_WITHIN_DEPARTMENT_IDS = [4, 13, 14]

function createToolbarFilterState () {
  return {
    // Payload-backing filters — every one of these is sent by searchConversation()
    keyword: null,
    selectedTagIds: [],
    filterByAndOr: 0,
    adminIds: [],
    assignedWithin: null,
    // unread / isNotResponse default to null, not 0. Verified against the live API: absent, `0`
    // and `null` return byte-identical responses, so clearSearch() behaves exactly as it does today.
    unread: null,
    isNotResponse: null,
    isReminder: 0,
    isEmergency: 0,
    selectedProvinceId: null,
    selectedProfessional: null,
    conversationCreatedDate: null,
    professionalGroup: null,
    // Mirrors of the above + panel search boxes — not sent, but they render the chips/indicators
    selectedTags: null,
    selectedAdmins: [],
    selectedChatTopic: null,
    tagFilterQuery: '',
    adminFilterQuery: '',
    professionals: [],
    proSuggestOpen: false,
    proSuggestLoading: false,
    proSuggestIndex: -1,
    // Panel flags — reset in the same synchronous block, so no frame shows an open panel with
    // values that were just cleared
    showSearch: false,
    showTag: false,
    showFilter: false,
    showQuickFilter: false,
    showAdmin: false,
    showGroup: false,
    showAssignedWithin: false,
    showDate: false,
    showDateCalendar: false
  }
}

export default {
  name: 'inbox-toolbar-v2026',
  components: {
    OverlayCard,
    MonthCalendarV2026
  },
  props: {
    searchConversationParams: Object
  },
  data () {
    return {
      toolIcons: {
        chatAdd: require('@/assets/icons2026/chat-add.svg'),
        search: require('@/assets/icons2026/search.svg'),
        tag: require('@/assets/icons2026/tag.svg'),
        contact: require('@/assets/icons2026/contact.svg'),
        filter: require('@/assets/icons2026/filter.svg'),
        userGroup: require('@/assets/icons2026/user-group.svg'),
        calendar: require('@/assets/icons2026/calendar.svg')
      },
      // true = โชว์ปุ่มกรวย "กรองตามหัวข้อ" บน rail Recruit ด้วย
      useTopicFilterOnRecruitment: false,
      // ส่งให้ OverlayCard เป็น :ignore
      dateFieldEl: null,
      // เดือนที่ปฏิทินเปิดดูอยู่ คนละตัวกับวันที่ที่เลือก
      createdDateMonth: null,
      // Filters + panel flags come from the factory — a filter declared here would not reset on
      // rail switch. Put it in the factory instead.
      ...createToolbarFilterState(),
      // Rail-switch bookkeeping (not filter state, so outside the factory). Seeded from the prop so
      // first paint is already reconciled — otherwise it would reset and swallow the initial search.
      railBoundary: this.searchConversationParams ? this.searchConversationParams.customer_type : null,
      railSwitchTick: false,
      // Bumped per suggestion request so a slow, older response cannot overwrite a newer list.
      proSuggestSeq: 0,
      quickFilterBtnEl: null,
      assignedWithinBtnEl: null,
      tagBtnEl: null,
      adminBtnEl: null,
      filterBtnEl: null,
      groupBtnEl: null,
      provinces: [],
      visibleCollapse: false,
      unTaggedConversationQty: null,
      disableMenuTypes: ['resolved', 'line', 'facebook'],
      professionalGroupOptions: [
        { value: null, label: 'ทั้งหมด' },
        { value: 1, label: 'กลุ่ม A' },
        { value: 2, label: 'กลุ่ม B' },
        { value: 3, label: 'กลุ่ม C' },
        { value: 4, label: 'กลุ่ม H' },
        { value: -1, label: 'ยกเว้นกลุ่ม 0' },
        { value: 0, label: 'กลุ่ม 0' }
      ]
    }
  },
  computed: {
    ...mapState('tag', ['tags', 'systemTags', 'multiLevelTags']),
    ...mapState('admin', ['admin', 'admins', 'departmentTagIds']),
    ...mapState('conversation', ['customerType']),
    ...mapState('tag', ['countTaggedConversation']),
    ...mapState('chatTopic', ['chatTopics', 'parentChatTopics']),
    ...mapState('menu', { menuCount: 'menuCount', menuType: 'type' }),

    conditionClearChatTopic () {
      if (this.selectedTags && this.selectedTags.length > 0) {
        const hasTagSystem = this.selectedTags.find(item => item.system)
        if ((hasTagSystem && !this.disableMenuTypes.includes(this.menuType)) || (this.customerType === 'beneat_professional' && !this.disableMenuTypes.includes(this.menuType) && this.selectedChatTopic)) {
          return true
        }
      }
      return false
    },
    showRecruitmentCreatedDateFilter () {
      return this.searchConversationParams &&
        ['recruitment_customer', 'recruitment_professional', 'recruitment_professional_secondary'].includes(this.searchConversationParams.customer_type)
    },
    conversationCreatedDateStr () {
      return this.conversationCreatedDate ? moment(this.conversationCreatedDate).format('YYYY-MM-DD') : null
    },
    conversationCreatedDateLabel () {
      return this.conversationCreatedDate
        ? moment(this.conversationCreatedDate).format('DD/MM/YYYY')
        : 'วันที่เริ่มสนทนา'
    },
    dateCalendarRenderKey () {
      return (this.conversationCreatedDateStr || 'none') + '#' +
        (this.createdDateMonth ? moment(this.createdDateMonth).format('YYYY-MM') : '')
    },
    reminderChipVisible () {
      return this.isReminder === 1 &&
        this.searchConversationParams &&
        this.searchConversationParams.customer_type === 'customer' &&
        this.searchConversationParams.menu !== 'reminder'
    },
    emergencyChipVisible () {
      return this.isEmergency === 1 &&
        this.searchConversationParams &&
        this.searchConversationParams.customer_type === 'customer'
    },
    hasActiveQuickFilters () {
      return this.unread === 1 || this.isNotResponse === 1 ||
        this.reminderChipVisible || this.emergencyChipVisible ||
        !!this.assignedWithinChipLabel
    },
    assignedWithinOptions () {
      return ASSIGNED_WITHIN_OPTIONS
    },
    // เปิด rail แชทกับคุณลูกค้าอยู่ (เมนูไหนก็ได้) + อยู่แผนก Big Cleaning
    showAssignedWithinFilter () {
      const departmentId = this.admin ? Number(this.admin.department_id) : null
      return !!this.searchConversationParams &&
        this.searchConversationParams.customer_type === ASSIGNED_WITHIN_RAIL &&
        ASSIGNED_WITHIN_DEPARTMENT_IDS.indexOf(departmentId) !== -1
    },
    assignedWithinRenderKey () {
      return String(this.assignedWithin)
    },
    assignedWithinChipLabel () {
      const opt = ASSIGNED_WITHIN_OPTIONS.find(item => item.value === this.assignedWithin)
      return opt ? opt.label : null
    },
    selectedTagChips () {
      return (Array.isArray(this.selectedTags) ? this.selectedTags : [])
        .filter(t => t && t.name && !t.system)
    },
    hasSelectedTagChips () {
      return this.selectedTagChips.length > 0
    },
    selectedTopicChips () {
      return (Array.isArray(this.selectedTags) ? this.selectedTags : [])
        .filter(t => t && t.name && t.system)
    },
    hasSelectedTopicChips () {
      return this.selectedTopicChips.length > 0
    },
    selectedProfessionalLabel () {
      const p = this.selectedProfessional
      return p ? 'ID:' + p.id + ' ' + (p.full_name || '') : ''
    },
    hasFilterGroups () {
      return this.hasActiveQuickFilters || this.hasSelectedTagChips || this.hasSelectedTopicChips
    },
    filteredToolbarTags () {
      const q = (this.tagFilterQuery || '').trim().toLowerCase()
      return (this.tags || []).filter(t => (!q || (t.name || '').toLowerCase().includes(q)))
    },
    filteredAdmins () {
      const q = (this.adminFilterQuery || '').trim().toLowerCase()
      return (this.admins || []).filter(a => (!q || (a.name || '').toLowerCase().includes(q)))
    },
    tagCardRenderKey () {
      return (this.selectedTagIds || []).join('|')
    },
    quickFilterRenderKey () {
      return [this.unread, this.isNotResponse, this.isReminder, this.isEmergency].join('|')
    },
    hasAdminFilter () {
      return this.adminIds.length > 0
    },
    adminCardRenderKey () {
      return this.hasAdminFilter ? this.adminIds.join('|') : 'all'
    },
    topicCardRenderKey () {
      return (this.selectedTagIds || []).join('|') + '#' + (this.selectedChatTopic ? String(this.selectedChatTopic.id) : 'none')
    },
    groupCardRenderKey () {
      return String(this.professionalGroup)
    },
    professionalGroupLabel () {
      const labels = {
        0: 'กลุ่ม 0',
        1: 'กลุ่ม A',
        2: 'กลุ่ม B',
        3: 'กลุ่ม C',
        4: 'กลุ่ม H',
        '-1': 'ยกเว้นกลุ่ม 0'
      }
      return labels[this.professionalGroup] || ''
    }
  },
  watch: {
    countTaggedConversation () {
      this.updateUnTaggedConversation()
    },
    menuCount () {
      this.updateUnTaggedConversation()
    },
    menuType () {
      // Ordering contract, explicit (do NOT rely on watcher declaration order): rail reset FIRST.
      // Without it this searches with stale filters and a later reset wipes the tag seed below.
      this.syncRailBoundary()
      // ตัวกรอง admin ไม่ข้ามเมนู. ต้องล้างตรงนี้ ก่อน search ข้างล่าง ไม่งั้น request แรก
      // ของเมนูใหม่ยังพ่วง admin เดิมไป
      this.clearAdminFilter()
      if (this.menuType === 'active' && this.customerType === 'customer') {
        if (this.departmentTagIds) {
          this.selectedTagIds = this.departmentTagIds
          this.selectedTags = []
          for (let tagId of this.selectedTagIds) {
            this.selectedTags.push({ id: tagId, system: 1 })
          }
        }
        this.searchConversation()
        this.updateUnTaggedConversation()
      } else {
        this.onChange(null)
      }
      this.selectedChatTopic = null // Clear chat topic when change menu type
      if (this.menuType && this.disableMenuTypes.includes(this.menuType)) {
        this.visibleCollapse = false
      }
    },
    // ตาข่ายกันพลาดสำหรับการเปลี่ยนเมนูที่ไม่ผ่าน watcher menuType (เช่น deep link) — idempotent.
    // เดิมบล็อกนี้เคลียร์แค่ `admin` ที่วาด chip ปล่อย `adminId` ที่ส่งจริงค้างไว้
    // ⇒ รายการถูกกรองด้วยแอดมินที่ไม่มีอะไรบนจอบอก และไม่มี chip ให้กดล้าง
    'searchConversationParams.menu': function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.clearAdminFilter()
    },
    keyword () {
      if (!this.keyword) {
        this.searchConversation()
      }
    },
    'searchConversationParams.customer_type' (newVal, oldVal) {
      // The only watcher that fires on the deep-link rail switch (it changes no menu and emits no
      // search). The newVal !== oldVal guard is what keeps first paint / mount reset-free.
      if (newVal !== oldVal) {
        this.syncRailBoundary()
      }
    },
    'searchConversationParams.conversation_created_date' () {
      this.syncConversationCreatedDate()
    },
    // ปุ่มกรวยเป็น v-if ตาม rail — ref เกิด/หายหลัง mounted ต้องเก็บใหม่ทุกครั้งที่สลับ
    showRecruitmentCreatedDateFilter () {
      this.$nextTick(() => {
        this.filterBtnEl = this.$refs.filterBtn || null
      })
    }
  },
  methods: {
    ...mapActions('admin', ['fetchAdmins']),
    ...mapActions('tag', ['fetchTags', 'fetchSystemTags']),
    ...mapActions('chatTopic', ['fetchProfessionalChatTopics', 'fetchParentChatTopics']),
    // Rail boundary = the customer_type the filter state is reconciled to. Filters set on one rail
    // must never keep filtering another: most have no control there, so the admin can neither see
    // nor cancel them. Idempotent — no-ops unless the rail changed, so it is safe to call from
    // anywhere and does not depend on watcher order.
    // State-only, never emits: the parent already refetched the destination rail, and everything
    // the reset re-triggers in the same flush is suppressed via railSwitchTick, so a rail switch
    // produces exactly ONE request.
    syncRailBoundary () {
      const rail = this.searchConversationParams
        ? this.searchConversationParams.customer_type
        : null
      if (rail === this.railBoundary) {
        return false
      }
      this.railBoundary = rail
      this.railSwitchTick = true
      // One synchronous assignment => one flush, one paint: reset values are never legible on screen.
      Object.assign(this, createToolbarFilterState())
      this.$nextTick(() => {
        this.railSwitchTick = false
      })
      return true
    },
    togglePanel (panel) {
      this.showSearch = panel === 'search' ? !this.showSearch : false
      this.showTag = panel === 'tag' ? !this.showTag : false
      this.showFilter = panel === 'filter' ? !this.showFilter : false
      this.showQuickFilter = panel === 'quickfilter' ? !this.showQuickFilter : false
      this.showAdmin = panel === 'admin' ? !this.showAdmin : false
      this.showGroup = panel === 'group' ? !this.showGroup : false
      this.showAssignedWithin = panel === 'assignedWithin' ? !this.showAssignedWithin : false
      this.showDate = panel === 'date' ? !this.showDate : false
      if (!this.showDate) {
        this.showDateCalendar = false
      }
      if (this.showTag) {
        this.tagFilterQuery = ''
      }
      if (this.showAdmin) {
        this.adminFilterQuery = ''
      }
    },
    hasSelectTagId (tagId) {
      return this.selectedTagIds.includes(tagId)
    },
    toggleTagPill (tag) {
      const current = Array.isArray(this.selectedTags) ? this.selectedTags.slice() : []
      const targetId = String(tag.id)
      const exists = current.some(t => String(t.id) === targetId)
      const next = exists
        ? current.filter(t => String(t.id) !== targetId)
        : current.concat(tag)
      this.onChange(next)
    },
    goToTagSetting () {
      this.$router.push('/settings/tag')
    },
    clearSelectedChatTopic () {
      this.selectedChatTopic = null
      this.searchConversation()
    },
    selectProfessionalGroup (value) {
      this.professionalGroup = value
      this.searchConversation()
      this.showGroup = false
    },
    // เลือกได้ทีละอัน — ส่งค่าเดิมกลับมา (กดซ้ำ) หรือ null = ล้าง
    selectAssignedWithin (value) {
      this.assignedWithin = this.assignedWithin === value ? null : value
      this.searchConversation()
    },
    removeQuickFilter (key) {
      this[key] = 0
      this.searchConversation()
    },
    syncConversationCreatedDate () {
      const conversationCreatedDate = this.searchConversationParams
        ? this.searchConversationParams.conversation_created_date
        : null
      if (!conversationCreatedDate) {
        this.conversationCreatedDate = null
        return
      }

      const parsedDate = moment(conversationCreatedDate, 'YYYY-MM-DD', true)
      this.conversationCreatedDate = parsedDate.isValid() ? parsedDate.toDate() : null
    },
    clearCreatedDate () {
      this.conversationCreatedDate = null
      this.showDateCalendar = false
      this.searchConversation()
    },
    toggleDateCalendar () {
      if (!this.showDateCalendar) {
        // เปิดที่เดือนของวันที่ที่เลือกไว้
        this.createdDateMonth = this.conversationCreatedDate
          ? moment(this.conversationCreatedDate)
          : moment()
      }
      this.showDateCalendar = !this.showDateCalendar
    },
    onCreatedDateSelect (dateStr) {
      this.conversationCreatedDate = moment(dateStr, 'YYYY-MM-DD').toDate()
      this.showDateCalendar = false
      this.searchConversation()
    },
    getAllTags () {
      let formatData = Array.isArray(this.multiLevelTags) ? this.multiLevelTags : []
      let temp = []
      formatData.forEach(item => {
        if (item.child_tags) {
          temp.push(item.child_tags)
        }
      })
      temp = temp.flat()
      return formatData.concat(temp)
    },
    updateUnTaggedConversation () {
      this.unTaggedConversationQty = null
      if (this.menuCount && typeof this.countTaggedConversation === 'number') {
        switch (this.menuType) {
          case 'inbox':
            this.unTaggedConversationQty = this.menuCount.inboxCustomerCount - this.countTaggedConversation
            break
          case 'reminder':
            this.unTaggedConversationQty = this.menuCount.reminderCustomerCount - this.countTaggedConversation
            break
          case 'active':
            this.unTaggedConversationQty = this.menuCount.activeCustomerCount - this.countTaggedConversation
            break
        }
      }
      this.updateActiveMenuCount()
    },
    updateActiveMenuCount () {
      if (this.menuType !== 'active' || this.customerType !== 'customer') {
        return
      }

      const fallbackActiveCount = this.menuCount && typeof this.menuCount.activeCustomerCount === 'number'
        ? this.menuCount.activeCustomerCount
        : null

      if (!Array.isArray(this.selectedTagIds) || this.selectedTagIds.length === 0) {
        if (fallbackActiveCount !== null) {
          this.$emit('onUpdateActiveMenu', fallbackActiveCount)
        }
        return
      }

      const allTags = this.getAllTags()
      let sumCount = 0
      let hasResolvedSelectedCount = false

      if (this.selectedTagIds.includes(0) && typeof this.unTaggedConversationQty === 'number') {
        sumCount += this.unTaggedConversationQty
        hasResolvedSelectedCount = true
      }

      for (const tag of allTags) {
        if (this.selectedTagIds.includes(tag.id) && typeof tag.tag_count === 'number') {
          sumCount += tag.tag_count
          hasResolvedSelectedCount = true
        }
      }

      if (!hasResolvedSelectedCount && fallbackActiveCount !== null) {
        this.$emit('onUpdateActiveMenu', fallbackActiveCount)
        return
      }

      this.$emit('onUpdateActiveMenu', sumCount)
    },
    isAdminSelected (a) {
      return !!(a && this.adminIds.some(id => String(id) === String(a.id)))
    },
    toggleAdmin (a) {
      if (!a) {
        return
      }
      const selected = this.isAdminSelected(a)
      // assign ก้อนใหม่เสมอ ห้าม push — :key ของแถวอ่านจาก array นี้
      this.adminIds = selected
        ? this.adminIds.filter(id => String(id) !== String(a.id))
        : this.adminIds.concat([a.id])
      this.selectedAdmins = selected
        ? this.selectedAdmins.filter(item => String(item.id) !== String(a.id))
        : this.selectedAdmins.concat([a])
      this.emitAdminChange()
    },
    selectAll () {
      this.clearAdminFilter()
      this.emitAdminChange()
    },
    // ล้าง state อย่างเดียว ไม่ยิง search — คนเรียกเป็นคนตัดสินใจว่าจะ search ต่อไหม
    clearAdminFilter () {
      this.adminIds = []
      this.selectedAdmins = []
      this.$store.commit('conversation/SET_SELECTED_ADMINS', [])
    },
    emitAdminChange () {
      this.searchConversation()
      this.$store.commit('conversation/SET_SELECTED_ADMINS', this.selectedAdmins.slice())
      this.fetchParentChatTopics()
    },
    searchProfessional: _.debounce(async (loading, search, vm) => {
      let url = `beneat/professionals?keywords=${escape(search)}`
      try {
        let { data } = await axios.get(url)
        vm.professionals = data.professionals
      } catch (e) {
        alert('ค้นหาผิดพลาด: ' + e.message)
      }
      loading(false)
    }, 350),
    // params, not the escape() above: escape() turns Thai into %uXXXX, which the API cannot decode.
    async fetchProSuggest (query) {
      const seq = ++this.proSuggestSeq
      let list = []
      try {
        const { data } = await axios.get('beneat/professionals', { params: { keywords: query } })
        list = (data && Array.isArray(data.professionals)) ? data.professionals : []
      } catch (e) {
        list = []
      }
      if (seq !== this.proSuggestSeq) return
      this.professionals = list
      this.proSuggestLoading = false
    },
    onKeywordInput (value) {
      if (this.customerType !== 'beneat_professional') return
      const query = (value || '').trim()
      if (!query) {
        this.closeProSuggest()
        return
      }
      this.proSuggestIndex = -1
      this.proSuggestOpen = true
      this.proSuggestLoading = true
      this.suggestProfessionals(query)
    },
    closeProSuggest () {
      this.suggestProfessionals.cancel()
      this.proSuggestSeq++
      this.proSuggestOpen = false
      this.proSuggestLoading = false
      this.proSuggestIndex = -1
    },
    moveProSuggest (step) {
      if (!this.proSuggestOpen || this.proSuggestLoading || !this.professionals.length) return
      const last = this.professionals.length - 1
      const next = this.proSuggestIndex + step
      this.proSuggestIndex = next < 0 ? last : (next > last ? 0 : next)
    },
    // Enter with a highlighted suggestion picks it; otherwise it is the plain keyword search it always was.
    onSearchEnter () {
      const picked = this.proSuggestOpen && !this.proSuggestLoading ? this.professionals[this.proSuggestIndex] : null
      if (picked) {
        this.pickProfessional(picked)
        return
      }
      this.closeProSuggest()
      this.searchConversation()
    },
    pickProfessional (professional) {
      this.selectedProfessional = professional
      this.closeProSuggest()
      // The keyword watcher emits the search when the keyword empties; calling it here too would
      // fire the request twice.
      if (this.keyword) {
        this.keyword = null
      } else {
        this.searchConversation()
      }
    },
    professionalChanged (professional) {
      this.searchConversation()
    },
    onSearchProfessional (search, loading) {
      loading(true)
      if (!escape(search).trim()) {
        loading(false)
      }
      this.searchProfessional(loading, search, this)
    },
    async onChange (tags) {
      if (!tags) {
        this.selectedTags = null
        this.selectedTagIds = []
        this.searchConversation()
        return
      }

      if (typeof tags === 'object' && !Array.isArray(tags) && tags !== null) {
        tags = [tags]
      }

      if (!Array.isArray(this.selectedTags)) {
        this.selectedTags = []
      }

      let tagIds = []

      tagIds = tags.map(tag => tag.id)

      this.selectedTags = tags
      this.selectedTagIds = tagIds
      await nextTick()
      this.searchConversation()
      this.updateActiveMenuCount()
    },
    // Public by name/signature (the parent calls it) — both must stay. It deliberately keeps its
    // own narrow subset: applying the whole factory here would clear filters and close panels on
    // paths that never did.
    clearSearch (clearOnlyRadio = false) {
      const defaults = createToolbarFilterState()
      if (!clearOnlyRadio) {
        this.keyword = defaults.keyword
        this.selectedAdmins = defaults.selectedAdmins
        this.adminIds = defaults.adminIds
        this.selectedTags = defaults.selectedTags
        this.selectedChatTopic = defaults.selectedChatTopic
        this.selectedProvinceId = defaults.selectedProvinceId
        this.selectedProfessional = defaults.selectedProfessional
        this.conversationCreatedDate = defaults.conversationCreatedDate
        this.assignedWithin = defaults.assignedWithin
      }
      this.isNotResponse = defaults.isNotResponse
      this.unread = defaults.unread
      this.isReminder = defaults.isReminder
    },
    searchKeyword () {
      const text = this.keyword ? stripLeadingStatusEmoji(this.keyword.trim()).trim() : ''
      return text || null
    },
    searchConversation () {
      // Every emit path in this file funnels through here, so the rail reset is reconciled here too.
      this.syncRailBoundary()
      if (this.railSwitchTick) {
        return
      }
      // NOTE: every filter below is initialised and reset by createToolbarFilterState().
      // Adding a key here without adding it there makes it leak across rails.
      const searchData = {
        page: 0,
        keyword: this.searchKeyword(),
        tag_id: null,
        filter_by_and_or: this.filterByAndOr,
        admin_id: this.hasAdminFilter ? this.adminIds.slice() : null,
        unread: this.unread,
        is_not_response: this.isNotResponse,
        is_reminder: this.isReminder,
        is_emergency: this.isEmergency,
        province_id: this.selectedProvinceId,
        professional_id: this.selectedProfessional ? this.selectedProfessional.id : null,
        conversation_created_date: this.conversationCreatedDate ? moment(this.conversationCreatedDate).format('YYYY-MM-DD') : null,
        assigned_within: this.assignedWithin,
        from_search: true,
        professional_group: this.professionalGroup
      }
      if (this.selectedTagIds && this.selectedTagIds.length > 0) {
        searchData.tag_id = this.selectedTagIds
      }
      this.$emit('onSearch', searchData)
    },
    searchConversationByChatTopicIds (parentChatTopic) {
      this.syncRailBoundary()
      if (this.railSwitchTick) {
        return
      }
      this.selectedChatTopic = parentChatTopic
      const childChatTopicIds = parentChatTopic.child_chat_topic_ids
      if (childChatTopicIds && childChatTopicIds.length > 0) {
        const searchData = {
          page: 0,
          keyword: this.searchKeyword(),
          tag_id: null,
          admin_id: this.hasAdminFilter ? this.adminIds.slice() : null,
          unread: this.unread,
          is_not_response: this.isNotResponse,
          is_reminder: this.isReminder,
          province_id: this.selectedProvinceId,
          professional_id: this.selectedProfessional ? this.selectedProfessional.id : null,
          from_search: true,
          beneat_chat_topic_ids: childChatTopicIds
        }
        this.$emit('onSearch', searchData)
      }
    },
    async fetchProvince () {
      try {
        let { data } = await axios.get('/provinces')
        this.provinces = data.provinces
      } catch (err) {
        this.$swal({ text: err.message, type: 'error' })
      }
    }
  },
  created () {
    // Built here, not in `methods`: Vue binds every method, which drops lodash's .cancel().
    this.suggestProfessionals = _.debounce(query => this.fetchProSuggest(query), 350)
  },
  beforeDestroy () {
    this.suggestProfessionals.cancel()
  },
  async mounted () {
    this.quickFilterBtnEl = this.$refs.quickFilterBtn
    this.assignedWithinBtnEl = this.$refs.assignedWithinBtn || null
    this.tagBtnEl = this.$refs.tagBtn
    this.adminBtnEl = this.$refs.adminBtn
    this.filterBtnEl = this.$refs.filterBtn
    this.groupBtnEl = this.$refs.groupBtn
    this.dateFieldEl = this.$refs.dateFieldBtn || null
    this.syncConversationCreatedDate()
    await this.fetchAdmins()
    await this.fetchProvince()
    await this.fetchTags({
      include_count: false,
      customer_type: this.customerType,
      system: 0
    })
    await this.fetchSystemTags({
      include_count: true,
      customer_type: 'customer',
      system: 1
    })
    this.$store.commit('conversation/SET_SELECTED_ADMIN', null)
    this.$store.commit('conversation/SET_SELECTED_ADMINS', [])
    this.fetchParentChatTopics()
  }
}
</script>

<style scoped>
.v2026-toolbar {
  background: #ffffff;

  position: relative;
}

.v2026-toolbar-icons {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
}

.v2026-tool-btn {
  border: none;
  background: transparent;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: #6c757d;
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.v2026-tool-btn:hover {
  color: #212529;
  background: var(--v2026-color-hover-bg);
}

.v2026-tool-btn.is-active {
  color: var(--v2026-color-main-icon);
  background: var(--v2026-color-main-soft);
}

.v2026-tool-btn--end {
  margin-left: auto;
}

.v2026-tool-svg-mask {
  display: inline-block;
  width: 18px;
  height: 18px;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-color-icon-idle);
}

.v2026-tool-btn:hover .v2026-tool-svg-mask,
.v2026-tool-btn.is-active .v2026-tool-svg-mask {
  background-color: var(--v2026-color-main);
}

.v2026-tool-panel {
  padding: 8px 12px 12px;
  border-top: 1px solid #f1f3f5;
}
.v2026-search-field {
  position: relative;
}

.v2026-search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);

  color: rgba(49, 193, 215, 0.65);
  font-size: 13px;
  line-height: 1;
  pointer-events: none;
}

.v2026-search-input.form-control-sm {
  height: 36px;
  padding: 0 12px 0 32px;
  border: 1px solid #31C1D740;
  border-radius: 999px;
  background-color: #ffffff;
}

.v2026-search-input.form-control-sm:focus {
  border-color: var(--v2026-color-main);
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
}

.v2026-prosuggest {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 30;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
}

.v2026-prosuggest__row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
}

.v2026-prosuggest__row.is-active {
  background: var(--v2026-color-hover-bg);
}

.v2026-prosuggest__avatar,
.v2026-pro-indicator__avatar {
  flex: 0 0 auto;
  border-radius: 50%;
  object-fit: cover;
}

.v2026-prosuggest__name {
  min-width: 0;
  font-size: 13px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2026-prosuggest__empty {
  padding: 8px;
  font-size: 13px;
  color: #9ca3af;
}

.v2026-date-panel {
  position: relative;
}

.v2026-date-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.v2026-date-field {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 34px 0 12px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.v2026-date-field.is-open {
  border-color: var(--v2026-color-main);
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft, rgba(49, 193, 215, 0.20));
}

/* ปุ่มใสทับทั้งช่อง = ตัวเปิดปฏิทิน */
.v2026-date-hit {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.v2026-date-hit:focus-visible {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 2px;
}

.v2026-date-value {
  position: relative;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  color: var(--v2026-text, #101828);
  pointer-events: none;
}

.v2026-date-value.is-empty {
  color: var(--v2026-text-muted, #98A2B3);
}

.v2026-date-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  color: var(--v2026-text-muted, #98A2B3);
  font-size: 13px;
  line-height: 1;
  pointer-events: none;
}

.v2026-date-clear {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  color: var(--v2026-text-secondary, #667085);
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease;
}

.v2026-date-clear:hover {
  border-color: var(--v2026-color-main);
  color: var(--v2026-color-main);
}

.v2026-date-clear:focus-visible {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 2px;
}

.v2026-date-calpos {
  top: calc(100% - 4px);
  left: 12px;
  right: 12px;
  padding: 8px;
}

.v2026-filter-groups {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 12px 10px;
}

.v2026-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.v2026-filter-group__title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #98A2B3;
}

.v2026-filter-groups__divider {
  height: 1px;
  background: #EBEDF0;
  margin: 2px 0;
  border: 0;
}

.v2026-active-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
}

.v2026-tag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
}

.v2026-tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 4px 6px 4px 8px;
  background: #ffffff;
  border: 1px solid var(--v2026-color-main);
  border-radius: 999px;
}

.v2026-tag-chip__ico {
  color: inherit;
  font-size: 13px;
  line-height: 1;
  flex-shrink: 0;
}

.v2026-tag-chip__label {
  color: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.v2026-tag-chip__remove {
  border: none;
  background: transparent;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  padding: 0;
  color: #9ca3af;
  font-size: 11px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.v2026-tag-chip__remove:hover {
  color: #374151;
  background: var(--v2026-color-hover-bg);
}

.v2026-tag-chip__remove:focus-visible {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 1px;
}

.v2026-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 4px 6px 4px 8px;
  background: #ffffff;
  border: 1px solid #EBEDF0;
  border-radius: 999px;
}

.v2026-filter-chip:hover {
  border-color: var(--v2026-color-main);
}

.v2026-filter-chip-check {
  color: var(--v2026-color-main);
  font-size: 15px;
  line-height: 1;
  flex-shrink: 0;
}

.v2026-filter-chip-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.v2026-filter-chip-remove {
  border: none;
  background: transparent;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  padding: 0;
  color: #9ca3af;
  font-size: 11px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.v2026-filter-chip-remove:hover {
  color: #374151;
  background: var(--v2026-color-hover-bg);
}

.v2026-filter-chip-remove:focus-visible {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 1px;
}

.v2026-quickfilter-pos {
  min-height: 171px;
}

.v2026-quickfilter-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f5;
}

.v2026-qf-check {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* ค้นหาแชทตามช่วงเวลา — แถวหน้าตาเดียวกับ StatusIconPickerV2026 แต่เลือกได้ทีละอัน */
.v2026-aw-pos {
  width: 260px;
  max-width: calc(100vw - 24px);
}

.v2026-aw-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f5;
}

.v2026-aw-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.v2026-aw-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  margin-bottom: 0;
  padding: 9px 14px;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  background: #FFFFFF;
  cursor: pointer;
  transition: border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease;
}

.v2026-aw-opt:hover {
  border-color: var(--v2026-color-main, #31C1D7);
}

.v2026-aw-opt--on {
  border-color: var(--v2026-color-main, #31C1D7);
  box-shadow: inset 0 0 0 1px var(--v2026-color-main, #31C1D7);
  background: var(--v2026-color-main-soft, #31C1D714);
}

.v2026-aw-opt__label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  line-height: 20px;
}

.v2026-aw-check {
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  width: 18px;
  height: 18px;
  line-height: 1;
}

/* input จริงถูกซ่อน แต่ยังรับ focus/keyboard ได้ กล่องที่เห็นคือ __box */
.v2026-aw-check__input {
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
  margin: 0;
  opacity: 0;
}

.v2026-aw-check__box {
  position: relative;
  width: 18px;
  height: 18px;
  border: 1.5px solid var(--v2026-color-main, #31C1D7);
  border-radius: 6px;
  background: #FFFFFF;
  pointer-events: none;
  transition: background-color 150ms ease;
}

.v2026-aw-check__box::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 4.5px;
  width: 5px;
  height: 9px;
  border: solid var(--v2026-color-main, #31C1D7);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 150ms ease;
}

.v2026-aw-check__input:checked + .v2026-aw-check__box {
  background: var(--v2026-color-main-soft, #31C1D714);
}

.v2026-aw-check__input:checked + .v2026-aw-check__box::after {
  opacity: 1;
}

.v2026-aw-check__input:focus-visible + .v2026-aw-check__box {
  outline: 2px solid var(--v2026-color-main, #31C1D7);
  outline-offset: 2px;
}

.v2026-qf-check .custom-control-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  padding-left: 4px;
  padding-top: 1px;
}

.v2026-qf-check .custom-control-label::before {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background-color: #ffffff;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.v2026-qf-check .custom-control-label:hover::before {
  border-color: var(--v2026-color-main);
}

.v2026-qf-check .custom-control-input:checked ~ .custom-control-label {
  color: #111827;
}

.v2026-qf-check .custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--v2026-color-main);
  border-color: var(--v2026-color-main);
}

.v2026-qf-check .custom-control-input:focus-visible ~ .custom-control-label::before {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 2px;
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.chat-topic-row:hover {
  background-color: #ECEFF1;
  cursor: pointer;
}

.filter-tooltip {
  position: absolute;
  top: -12px;
  right: -7px;
}

.filter-tooltip:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
}

.v2026-tagpanel-pos {
  width: 280px;
}

.v2026-tagpanel-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #F8FAFC;
  border: 1px solid #E4E7EC;
  border-radius: 10px;
}

.v2026-tagpanel-search:focus-within {
  border-color: var(--v2026-color-main);
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}

.v2026-tagpanel-search__ico {
  flex: 0 0 auto;
  font-size: 14px;
  color: #98A2B3;
}

.v2026-tagpanel-search__input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #101828;
  font-size: 14px;
}

.v2026-tagpanel-search__input::placeholder {
  color: #98A2B3;
}

.v2026-tagpanel-list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.v2026-tagpanel-list::-webkit-scrollbar {
  width: 6px;
}

.v2026-tagpanel-list::-webkit-scrollbar-thumb {
  background: #31C1D7;
  border-radius: 3px;
}

.v2026-tagpanel-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--v2026-color-main);
  border-radius: 14px;
  background: #ffffff;
  font-size: 12px;
  cursor: pointer;
}

.v2026-tagpanel-row:hover {
  background: #e9ecf1;
}

.v2026-tagpanel-row.is-selected {
  background: var(--v2026-color-main-soft);
  font-weight: 600;
}

.v2026-tagpanel-row:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
}

.v2026-tagpanel-row__ico {
  flex: 0 0 auto;
  font-size: 12px;
}

.v2026-tagpanel-row__name {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-tagpanel-row__check {
  flex: 0 0 auto;
  font-size: 12px;
}

.v2026-tagpanel-empty {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #98A2B3;
}

.v2026-tagpanel-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding: 8px;
  border-top: 1px solid #E4E7EC;
}

.v2026-tagpanel-foot__setting {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  color: #667085;
  font-size: 14px;
  cursor: pointer;
}

.v2026-tagpanel-foot__setting:hover {
  background: #e9ecf1;
  border-radius: 10px;
}

.v2026-tagpanel-foot__setting:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
  border-radius: 10px;
}

.v2026-tagpanel-foot__ico {
  flex: 0 0 auto;
  font-size: 12px;
  color: #667085;
}

.v2026-andor {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.v2026-andor__label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.v2026-andor__switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
  margin: 0;
  flex-shrink: 0;
}

.v2026-andor__switch input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
}

.v2026-andor__slider {
  position: absolute;
  inset: 0;
  background: #d1d5db;
  border-radius: 999px;
  transition: background-color 0.15s ease;
}

.v2026-andor__slider::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s ease;
}

.v2026-andor__switch:hover .v2026-andor__slider {
  background: #bcc2cc;
}

.v2026-andor__switch input:checked ~ .v2026-andor__slider {
  background: var(--v2026-color-main);
}

.v2026-andor__switch input:checked ~ .v2026-andor__slider:hover,
.v2026-andor__switch:hover input:checked ~ .v2026-andor__slider {
  background: var(--v2026-color-main);
}

.v2026-andor__switch input:checked ~ .v2026-andor__slider::before {
  transform: translateX(16px);
}

.v2026-andor__switch input:focus-visible ~ .v2026-andor__slider {
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
}

.v2026-andor__info {
  position: relative;
  top: 0;
  right: 0;
  color: #9ca3af;
  font-size: 13px;
  line-height: 1;
  cursor: help;
}

.v2026-adminpanel-pos {
  width: 280px;
}

.v2026-adminpanel-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #F8FAFC;
  border: 1px solid #E4E7EC;
  border-radius: 10px;
}

.v2026-adminpanel-search:focus-within {
  border-color: var(--v2026-color-main);
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}

.v2026-adminpanel-search__ico {
  flex: 0 0 auto;
  font-size: 14px;
  color: #98A2B3;
}

.v2026-adminpanel-search__input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #101828;
  font-size: 14px;
}

.v2026-adminpanel-search__input::placeholder {
  color: #98A2B3;
}

.v2026-adminpanel-list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.v2026-adminpanel-list::-webkit-scrollbar {
  width: 6px;
}

.v2026-adminpanel-list::-webkit-scrollbar-thumb {
  background: #31C1D7;
  border-radius: 3px;
}

.v2026-adminpanel-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 14px;
  background: #ffffff;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
}

.v2026-adminpanel-row:hover {
  background: #e9ecf1;
}

.v2026-adminpanel-row.is-selected {
  background: var(--v2026-color-main-soft);
  font-weight: 600;
}

.v2026-adminpanel-row:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
}

.v2026-adminpanel-row__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
}

.v2026-adminpanel-row__name {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-adminpanel-row__check {
  flex: 0 0 auto;
  font-size: 13px;
  color: var(--v2026-color-main);
}

.v2026-adminpanel-all__ico {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #F2F4F7;
  color: #667085;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.v2026-adminpanel-empty {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #98A2B3;
}

.v2026-admin-indicators {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 6px 12px 4px;
}

.v2026-admin-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px 4px 4px;
  background: #ffffff;
  border: 1px solid #31C1D740;
  border-radius: 999px;
}

.v2026-admin-indicator__avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
}

.v2026-admin-indicator__name {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 160px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-admin-indicator__remove {
  border: none;
  background: transparent;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 0;
  color: #9ca3af;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.v2026-admin-indicator__remove:hover {
  color: #374151;
  background: var(--v2026-color-hover-bg);
}

.v2026-admin-indicator__remove:focus-visible {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 1px;
}

.v2026-group-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 12px 4px;
  padding: 4px 6px 4px 8px;
  background: #ffffff;
  border: 1px solid #31C1D740;
  border-radius: 999px;
}

.v2026-group-indicator__check {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: var(--v2026-color-main);
}

.v2026-group-indicator__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-group-indicator__remove {
  border: none;
  background: transparent;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 0;
  color: #9ca3af;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.v2026-group-indicator__remove:hover {
  color: #374151;
  background: var(--v2026-color-hover-bg);
}

.v2026-group-indicator__remove:focus-visible {
  outline: 2px solid var(--v2026-color-main);
  outline-offset: 1px;
}

.v2026-topic-pos {
  width: 300px;
}

.v2026-topic-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f5;
}

.v2026-topic-prosel {
  margin-bottom: 6px;
}

.v2026-topic-prosel .form-group {
  margin-bottom: 8px;
}

.v2026-topic-list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.v2026-topic-list::-webkit-scrollbar {
  width: 6px;
}

.v2026-topic-list::-webkit-scrollbar-thumb {
  background: #31C1D7;
  border-radius: 3px;
}

.v2026-topic-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 10px;
  background: #ffffff;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
}

.v2026-topic-row:hover {
  background: #e9ecf1;
}

.v2026-topic-row.is-selected {
  background: var(--v2026-color-main-soft);
  font-weight: 600;
}

.v2026-topic-row:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--v2026-color-main-soft);
}

.v2026-topic-row__name {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2026-topic-row__count {
  flex: 0 0 auto;
  font-size: 12px;
  color: #6b7280;
}

.v2026-topic-row__check {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: transparent;
}

.v2026-topic-row.is-selected .v2026-topic-row__check {
  background: var(--v2026-color-main);
  border-color: var(--v2026-color-main);
  color: #ffffff;
}

.v2026-topic-row__radio {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  background: #ffffff;
  position: relative;
}

.v2026-topic-row--radio.is-selected .v2026-topic-row__radio {
  border-color: var(--v2026-color-main);
}

.v2026-topic-row--radio.is-selected .v2026-topic-row__radio::after {
  content: '';
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: var(--v2026-color-main);
}

.v2026-topic-child {
  padding-left: 26px;
}

.v2026-topic-group-header {
  padding: 8px 10px 4px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #98A2B3;
}

.v2026-topic-sep {
  margin: 6px 0;
  border: 0;
  border-top: 1px solid #EBEDF0;
}

.v2026-topic-foot {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #E4E7EC;
}

.v2026-group-pos {
  width: 250px;
}

.v2026-group-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f5;
}

.v2026-group-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
</style>
